module.exports = __webpack_public_path__ + "static/media/Dezioral_CBD_olej_sprej_retina.16800152.jpg";